import { NavMarker } from 'react-rhumb';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseErrorView = ({
  children,
  errorKey
}) => {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: 'ERROR_SCREEN',
    children: /*#__PURE__*/_jsx("div", {
      "data-error": errorKey,
      "data-selenium": `${errorKey}_VIEW`,
      children: /*#__PURE__*/_jsx("div", {
        className: `text-center`,
        children: /*#__PURE__*/_jsx(AnimatedStepBody, {
          children: children
        })
      })
    })
  });
};